import kaseyaBmsLogo from '../../../../images/cc/kaseya_bms_logo.png';
import kaseyaIcon from '../../../../images/cc/kaseya-24x24.png';

import { createDefaultService } from '../../services';

export default {
    name: 'kaseyabms',
    label: 'Kaseya BMS',
    agreementLabel: 'Contract',
    enabled: true,
    visible: true,
    guide_url: 'kaseya_bms_setup_guide_url',
    logo: kaseyaBmsLogo,
    icon: kaseyaIcon,
    serviceProvider: createDefaultService('kaseyabms'),
    methods: {
        isInstalled(service) {
            return !!(service && service.extra && service.extra.host);
        },
    },
};
